(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var button = document.querySelector('[data-back-to-top]');
    if (!button) return;

    var SHOW_THRESHOLD = 480;
    var ticking = false;

    function updateVisibility() {
      button.dataset.visible = String(window.scrollY > SHOW_THRESHOLD);
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(updateVisibility);
          ticking = true;
        }
      },
      { passive: true },
    );

    updateVisibility();

    button.addEventListener('click', function () {
      if (window.lenis) {
        window.lenis.scrollTo(0);
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var body = drawer.querySelector('[data-cart-body]');
    var shipping = drawer.querySelector('[data-cart-shipping]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var crosssell = drawer.querySelector('[data-cart-crosssell]');
    var toast = drawer.querySelector('[data-cart-toast]');
    var toastMessage = toast.querySelector('[data-cart-toast-message]');
    var toastUndo = toast.querySelector('[data-cart-toast-undo]');
    var toastTimer;
    var pendingUndo = null;

    // Plain overflow: hidden (same lock used by predictive-search.liquid
    // and the collection filters drawer) — NOT the position: fixed + top
    // offset trick. That trick forces window.scrollY to 0 as a side
    // effect (the body leaves normal flow), and on real mobile browsers
    // that shows up as a visible jump to the top before the compensating
    // top offset "catches up", then another jump back on close. Plain
    // overflow: hidden never moves the body out of flow, so scrollY
    // never changes and there's nothing to restore on close.
    function open() {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      drawer.dataset.open = 'true';
      drawer.setAttribute('aria-hidden', 'false');
    }

    function close() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      drawer.dataset.open = 'false';
      drawer.setAttribute('aria-hidden', 'true');
    }

    function showToast(message, snapshot) {
      pendingUndo = snapshot || null;
      toastMessage.textContent = message;
      toast.hidden = false;
      toastUndo.style.display = snapshot ? '' : 'none';
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.hidden = true;
      }, 5000);
    }

    toastUndo.addEventListener('click', function () {
      if (pendingUndo && pendingUndo.id) {
        window.GasCart.addItem(pendingUndo.id, pendingUndo.quantity);
      }
      toast.hidden = true;
    });

    function render(cart) {
      subtotalEl.textContent = window.GasCart.formatMoney(cart.total_price, cart.currency);

      body.innerHTML = window.GasCart.renderLines(cart, {
        emptyLabel: body.dataset.emptyLabel,
        emptyCtaLabel: body.dataset.emptyCtaLabel,
        emptyCtaHref: body.dataset.emptyCtaHref,
      });

      if (shipping) {
        var threshold = Number(shipping.dataset.threshold || 0) * 100;
        shipping.innerHTML = window.GasCart.renderShippingBar(cart, threshold);
      }

      if (crosssell) {
        var items = crosssell.querySelectorAll('.crosssell-item');
        var cartVariantIds = cart.items.map(function (item) {
          return String(item.variant_id);
        });
        items.forEach(function (item) {
          var btn = item.querySelector('[data-crosssell-add]');
          var variantId = btn ? btn.dataset.crosssellAdd : null;
          item.hidden = cart.item_count === 0 || (variantId && cartVariantIds.indexOf(variantId) !== -1);
        });
      }
    }

    window.GasCart.bindLineActions(body, {
      onRemoved: function (snapshot) {
        showToast(snapshot.title + ' ' + (drawer.dataset.removedLabel || 'eliminado'), snapshot);
      },
    });

    if (crosssell) {
      crosssell.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-crosssell-add]');
        if (!btn) return;
        window.GasCart.addItem(btn.dataset.crosssellAdd, 1);
      });
    }

    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.dataset.open === 'true') close();
    });

    document.addEventListener('cart:updated', function (event) {
      render(event.detail);
    });

    document.addEventListener('cart:open', function () {
      var cached = window.GasCart.getState();
      if (cached) render(cached);
      open();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;

    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var form = overlay.querySelector('[data-search-form]');

    function open() {
      overlay.dataset.open = 'true';
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        input.focus();
      }, 50);
    }

    function close() {
      overlay.dataset.open = 'false';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function productImage(product) {
      return product.image ? product.image.replace(/(\.[^.?]+)(\?|$)/, '_112x$1$2') : '';
    }

    async function renderResults(query) {
      if (!query.trim()) {
        results.innerHTML = '<p class="search-overlay__hint">' + results.dataset.hintLabel + '</p>';
        return;
      }

      var data = await window.GasSearch.suggest(query, { limit: 6 });
      var matches = data.products;

      if (matches.length === 0) {
        results.innerHTML =
          '<p class="search-overlay__empty">' + results.dataset.emptyLabelTemplate.replace('__QUERY__', query) + '</p>';
        return;
      }

      results.innerHTML =
        matches
          .map(function (product) {
            return (
              '<a class="search-result" href="' +
              product.url +
              '"><img class="search-result__image" src="' +
              productImage(product) +
              '" alt="' +
              product.title +
              '" /><div class="search-result__info"><p class="search-result__title">' +
              product.title +
              '</p><p class="search-result__category">' +
              (product.product_type || '') +
              '</p></div><span class="search-result__price">' +
              product.price +
              '</span></a>'
            );
          })
          .join('') +
        '<a class="search-overlay__viewall" href="/search?q=' +
        encodeURIComponent(query) +
        '&type=product">' +
        results.dataset.viewAllLabel +
        '</a>';
    }

    input.addEventListener('input', function () {
      renderResults(input.value);
    });

    overlay.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.dataset.open === 'true') close();
      if ((event.key === '/' || (event.metaKey && event.key === 'k')) && overlay.dataset.open !== 'true') {
        var active = document.activeElement;
        var isTyping = active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA');
        if (!isTyping) {
          event.preventDefault();
          open();
        }
      }
    });

    document.addEventListener('search:open', function () {
      renderResults(input.value);
      open();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-quick-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    window.GasCart.addItem(variantId, 1).then(function () {
      window.GasCart.open();
    });
  });

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-swatch-color]');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();

    var card = swatch.closest('.product-card');
    if (!card) return;

    card.querySelectorAll('[data-swatch-color]').forEach(function (other) {
      other.setAttribute('aria-pressed', String(other === swatch));
    });

    var imageUrl = swatch.dataset.swatchImage;
    var img = card.querySelector('.product-card__image');
    if (imageUrl && img) {
      img.removeAttribute('srcset');
      img.src = imageUrl;
    }
  });

  document.querySelectorAll('.product-card__media').forEach(function (media) {
    var images = [];
    try {
      images = JSON.parse(media.dataset.cardImages || '[]');
    } catch (e) {
      images = [];
    }
    if (images.length < 2) return;

    var img = media.querySelector('.product-card__image');
    if (!img) return;

    var originalSrc = img.getAttribute('src');
    var originalSrcset = img.getAttribute('srcset');
    var index = 0;
    var timer = null;

    media.addEventListener('mouseenter', function () {
      index = 0;
      timer = setInterval(function () {
        index = (index + 1) % images.length;
        img.removeAttribute('srcset');
        img.src = images[index];
      }, 800);
    });

    media.addEventListener('mouseleave', function () {
      clearInterval(timer);
      index = 0;
      img.src = originalSrc;
      if (originalSrcset) img.setAttribute('srcset', originalSrcset);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smooth-scroll"] && !Shopify.designMode) return;
  try {
    (function () {
    if (typeof Lenis === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var lenis = new Lenis({
      autoRaf: false,
    });

    window.lenis = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  })();
  } catch(e) { console.error(e); }
})();

})();
